<template>
<div>
    <div class="row">
        <div :class="['col_12', {'loading_overlay': loading}]">
            <div class="card no_border">
                <div class="card-header">
                    <div class="card-title">{{ title }}</div>
                </div>
                <div class="card-body pl_0 pr_0">
                    <div class="row">
                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('title')}]">
                                <label>{{ $t('common.title') }}</label>
                                <input type="text" v-model="form.title" class="form_global">
                                <v-errors :errors="errorFor('title')" />
                            </div>
                        </div>
                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('category_id')}]">
                                <label>{{ $t('sidebar.faq_category.faq_category') }}</label>
                                <select v-model="form.category_id" class="form_global">
                                    <option value="">{{ $t('sidebar.faq.select_faq_category') }}</option>
                                    <option :value="item.id" v-for="item in categories" :key="'category_id '+item.id">{{ item.name }}</option>
                                </select>
                                <v-errors :errors="errorFor('category_id')" />
                            </div>
                        </div>
                        <div class="col_12">
                            <div :class="['form-group', {'has_error': errorFor('description')}]">
                                <label>{{ $t('sidebar.faq.description') }}</label>
                                <text-editor-component :id="'description'" :existingData="form.description ? form.description : ''" @change="changeEditorValue" />
                                <v-errors :errors="errorFor('description')" />
                            </div>
                        </div>
                    </div>
                    <div class="d_flex_end form_action_btn">
                        <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
                        <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import TextEditorComponent from "@/components/TextEditorComponent";
export default {
    data() {
        return {
            title: this.$t('sidebar.faq.add_faq'),
            cancelRouteName: 'faq_list',
            categories: [],
            form: {
                title: '',
                category_id: '',
                description: ''
            }
        }
    },
    components: {
        TextEditorComponent
    },
    created() {
      this.axios.get('/faq-categories').then((response) => this.categories = response.data.data);
      
      if (this.$route.name === 'faq_edit') {
          this.axios.get('/faqs/' + this.$route.params.id)
              .then((response) => {
                  this.form = response.data.data;
              })
          this.title = this.$t('sidebar.faq.edit_faq');
      }
    },
    methods: {
        changeEditorValue(editorId, data) {
            this.form[editorId] = data
        },
        submit() {
            this.allErrors = null;
            this.loading = true;

            if (this.$route.name === 'faq_edit') {
                this.axios.patch('/faqs/' + this.$route.params.id, this.form)
                    .then(() => {
                        this.$router.push({
                            name: 'faq_list'
                        });
                        this.showSuccessMsg(this.$t('common.updateSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.axios.post('/faqs', this.form)
                    .then(() => {
                        this.$router.push({
                            name: 'faq_list'
                        });
                        this.showSuccessMsg(this.$t('common.addSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
}
</script>
